























import ShipList from '@/views/Admin/Ship/ShipList.vue';
import ZoneList from '@/views/Admin/Ship/ZoneList.vue';
import FrameList from '@/views/Admin/Ship/FrameList.vue';
import TabCard from '@/components/Tabs.vue';
import {Vue, Component} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import CenterPoints from '@/views/Admin/CenterPoints/CenterPoints.vue';
@Component({
  computed: {...mapGetters(['currentTab'])},
  methods: {...mapActions(['setCurrentTab'])},
  components: {
    ShipList,
    ZoneList,
    FrameList,
    TabCard,
    CenterPoints,
  },
})
export default class ShipPanel extends Vue {
  setCurrentTab: any;
  initialTab: String = this.$store.getters.currentTab.child || 'shiplist';
  tabs: Array<String> = ['shiplist', 'zones', 'listOfFrame', 'CenterPoints'];

  changeTab(activeTab) {
    this.setCurrentTab({parent: 'ships', child: activeTab});
  }
}
